import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpinner = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "currentColor",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "spinner-gF01",
		children: [
			/* @__PURE__ */ _jsx("feGaussianBlur", {
				in: "SourceGraphic",
				stdDeviation: 1,
				result: "y"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "y",
				mode: "matrix",
				values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 18 -7",
				result: "z"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				in: "SourceGraphic",
				in2: "z"
			})
		]
	}) }), /* @__PURE__ */ _jsxs("g", {
		filter: "url(#spinner-gF01)",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 5,
				cy: 12,
				r: 4,
				children: /* @__PURE__ */ _jsx("animate", {
					attributeName: "cx",
					calcMode: "spline",
					dur: "2s",
					values: "5;8;5",
					keySplines: ".36,.62,.43,.99;.79,0,.58,.57",
					repeatCount: "indefinite"
				})
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 19,
				cy: 12,
				r: 4,
				children: /* @__PURE__ */ _jsx("animate", {
					attributeName: "cx",
					calcMode: "spline",
					dur: "2s",
					values: "19;16;19",
					keySplines: ".36,.62,.43,.99;.79,0,.58,.57",
					repeatCount: "indefinite"
				})
			}),
			/* @__PURE__ */ _jsx("animateTransform", {
				attributeName: "transform",
				type: "rotate",
				dur: "0.75s",
				values: "0 12 12;360 12 12",
				repeatCount: "indefinite"
			})
		]
	})]
});
export default SvgSpinner;
